import { markNotificationsSeen } from "@/services/rest/notification";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { notificationKeys } from "./notificationKeys";

export const useMarkNotificationsSeen = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      ids,
      isMarkAll,
    }: {
      ids?: Array<string | number>;
      isMarkAll?: boolean;
    }) => markNotificationsSeen({ notificationIds: ids, isMarkAll }),
    onSuccess: async () => {
      // invalidate notification queries so counts and lists refresh
      await queryClient.invalidateQueries({ queryKey: notificationKeys.all });
    },
  });
};
